import { combineReducers } from 'redux';

import * as types from './types';

export const initialState = {};

initialState.byID = {};
// eslint-disable-next-line @typescript-eslint/default-param-last
export const byID = (state = initialState.byID, { type, payload }) => {
  switch (type) {
    case types.FETCH_VAT_RATES.SUCCESS:
      return {
        ...state,
        ...payload.reduce((vats, vat) => ({ ...vats, [vat.id]: vat }), {}),
      };

    case types.SET_VAT_RATES.SUCCESS:
      return { ...state, [payload.id]: payload };
    default:
      return state;
  }
};

export default combineReducers({ byID });
